export const URL_TYPES = {
  LINK: 0,
  DOWNLOAD: 1
};
